import axios from "axios";
import {findWhere, isEmpty, pluck} from "underscore";

const REXAI_API = process.env.REXAI_API;
export const NOTIFICATION_TEMPLATE_TIMEOUT_MS = 95000;

const NO_NOTIFICATION_CONTENT = "No specific notification content required.";

const isEmptyHTML = (text) => {
  const clean = text
    ?.replace(/(<([^>]+)>)/gi, "")
    .replace(/&nbsp;/gi, "")
    .replace(/\s/g, "");
  return isEmpty(clean);
};

export const buildNotificationTemplateRequest = (regulation, forceNewTemplate = false) => {
  const notifications = pluck(regulation?.notifications, "notification");
  const regulatorNotification = findWhere(notifications, {type: "REGULATOR"});

  return {
    regulator: regulation?.regulator,
    source: regulation?.source,
    description: regulation?.description,
    notificationContent:
      isEmptyHTML(regulatorNotification?.content) ? NO_NOTIFICATION_CONTENT : (
        regulatorNotification.content
      ),
    forceNewTemplate,
  };
};

export const generateNotificationTemplate = async ({regulation, forceNewTemplate, idToken}) => {
  const response = await axios.post(
    `${REXAI_API}/v1/templates/regulation-notification`,
    buildNotificationTemplateRequest(regulation, forceNewTemplate),
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "X-Client-Platform": "web",
      },
      timeout: NOTIFICATION_TEMPLATE_TIMEOUT_MS,
    },
  );
  return response.data?.response ?? "";
};
